import WebsiteModal from "./WebsiteModal";

export default class TestimonialImageModal extends WebsiteModal {
    constructor(link) {
        super();

        this.link = link;
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--no-border-top modal--gallery modal--testimonial-image"}, [
                eotwJSXFactory('div', {className: "modal__bg"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('button', {type: "button", className: "modal__close js-close-modal"}),
                    eotwJSXFactory('img', {src: this.link, alt: ""})
                ])
            ])
        );
    }
}